export default __webpack_public_path__ + "static/media/alogo.cd791a32.png";